import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Modal,
  Button,
  Typography,
  Grid,
  Paper,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Tooltip,
  Checkbox,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import axios from "axios";
import { Close, Preview } from "@mui/icons-material";
import { AddCircle } from "@mui/icons-material"; 
import {
  setfallbackContentLogout,
  setfallbackContentMRListLogout,
  setfallbackContentSelectedId,
  setfallbackContentSelectedIdLogout,
} from "../../redux/slices/FallBackContent";
import MyEventCustomisationForm from "./MyEventCustomisationForm";
import MyContentLinkForm from "./MyContentLinkForm";
import { toast } from "react-toastify";
import { setScreenuser } from "../../redux/slices/screenusersSlice";

const FallBackContent = ({ setshowmodel }) => {
  const dispatch = useDispatch();
  const modalContainerRef = useRef(null);
  const [editCustomisationMRList, seteditCustomisationMRList] = useState([]);
  const screenUsers = useSelector((state) => state?.screenusers?.screenusers);
  const [removedMRFallBack, setremovedMRFallback] = useState([]);
  const [listofrightMRs, setlistofrightMRs] = useState(
    useSelector((state) => state?.screenusers?.screenusers)
  );
  const [newFallbackContent, setNewFallbackContent] = useState(false); 
  const [imageLink, setImageLink] = useState(""); 
  const [isImageUpload, setIsImageUpload] = useState(false);


  const eventcustomisations = useSelector(
    (state) => state?.eventcustomisations?.eventcustomisations
  );
  const fallbackContent = useSelector((state) => state?.fallbackContent);
  const [selectedOption, setSelectedOption] = useState(
    useSelector((state) => state?.curremms?.curremms?.id)
  );
  const [removedScreenUsers, setRemovedScreenUsers] = useState([]);

  const emms = useSelector((state) => state.emms);
  const [login, setLogin] = useState(false);

  const [responseData, setResponseData] = useState(null);
  const headers = useSelector((state) => state.header);

  const [selectedScreenUsers, setSelectedScreenUsers] = useState([]);
  const handleScreenUserSelect = (userId) => {
    setSelectedScreenUsers((prevSelected) => {
      if (prevSelected.includes(userId)) {
      
        setRemovedScreenUsers((prevRemoved) => [...prevRemoved, userId]);
        return prevSelected.filter((id) => id !== userId);
      } else {
     
        setRemovedScreenUsers((prevRemoved) =>
          prevRemoved.filter((id) => id !== userId)
        );
        return [...prevSelected, userId];
      }
    });
  };

  const [selectedFallbackId, setSelectedFallbackId] = useState(null);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const api = localStorage.getItem("api");
    const requestBody = {
      path: "screenusers",
      query: {  },

      emmsId: `${selectedOption}`,
      requestType: "GET",
      headers: {
        ...emmsheaders?.emmsheaders?.headers,
      },
    };
    axios
      .post(`${api}/emms/piggyback`, requestBody, headers)
      .then((data) => {
        setlistofrightMRs(data.data);
      })

      .catch(() => {});
  }, [fallbackContent?.fallbackContentSelectedId]);

  const filteredFallback = eventcustomisations?.filter(
    (item) => item.fallbackContent
  );

  const handleAddNewFallback = () => {
    setNewFallbackContent(true);
  };
  useEffect(() => {
    if (selectedFallbackId !== null) {
      const preselectedUsers = screenUsers
        ?.filter(
          (user) =>
            user?.customProperties?.fallbackCustomisationId ===
            selectedFallbackId
        )
        .map((user) => user.id);

      setSelectedScreenUsers(preselectedUsers);
    }
  }, [screenUsers, selectedFallbackId]);

  const handleBatchUpdateMrs = async () => {
    const api = localStorage.getItem("api");

    if (!fallbackContent?.fallbackContentSelectedId) {
      toast.error("Please select a fallback content.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    if (selectedScreenUsers.length === 0 && removedScreenUsers.length === 0) {
      toast.error("Please select at least one screen user.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    const isRemovingFallback = removedScreenUsers.length > 0;

    const data = {
      screenUserIds: isRemovingFallback
        ? removedScreenUsers
        : selectedScreenUsers,
      fallbackCustomisationId: isRemovingFallback ? null : selectedFallbackId,
    };

    const requestBody = {
      path: "screenusers/bulkupdate",
      query: {},
      body: data,
      emmsId: selectedOption,
      requestType: "POST",
      headers: { ...emmsheaders?.emmsheaders?.headers },
    };

    try {
      const response = await axios.post(
        `${api}/emms/piggyback`,
        requestBody,
        headers
      );

      const updatedUsers = response.data; 

     
      const newScreenUsers = screenUsers.map(
        (user) =>
          updatedUsers.find((updatedUser) => updatedUser.id === user.id) || user
      );

      dispatch(setScreenuser(newScreenUsers));

      toast.success("Successfully updated fallback content.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      setshowmodel(false);
    } catch (error) {
      toast.error("Error updating fallback content.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <Modal open onClose={() => setshowmodel(false)}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: {xs:"100%", md:"100vh"},
          width:{xs:"100%",md:"unset"},
          p: {xs:0,md:3},
        }}
      >
        <Paper
          elevation={3}
          sx={{
            display: "flex",
            width: {xs:'95%' , md:"80%"},
            height:  {xs:'95%' , md:"80%"},
            overflow: "hidden",
            borderRadius: "8px",
            flexDirection:{xs:"column",md:"row"}
          }}
        >
     
          <Box
            sx={{
              flex: {xs:2,md:1},
              display: "flex",
              flexDirection: "column",
              p: 2,
              borderRight: "1px solid #ccc",
              overflowY: "auto",
              borderBottom:{xs:'1px solid #ccc',md:"unset"}
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="h6" gutterBottom>
                Fallback Content List
              </Typography>
             
            </Box>

            
            {!newFallbackContent && (
              <Grid
                container
                spacing={1}
                sx={{ p: 2, overflowY: "auto", flex: 1 }}
              >
                {filteredFallback?.map((item) => (
                  <Grid item xs={12} key={item.id}>
                    <Card
                      sx={{
                        border:
                          selectedFallbackId === item.meetingCustomisationId
                            ? "2px solid #1976d2"
                            : "1px solid #ccc",
                        borderRadius: 2,
                      }}
                      onClick={() => {
                        setSelectedFallbackId(item.meetingCustomisationId);
                        dispatch(setfallbackContentSelectedIdLogout());
                        dispatch(
                          setfallbackContentSelectedId(
                            item.meetingCustomisationId
                          )
                        );
                      }}
                    >
                      <CardMedia
                        component="img"
                        height="140"
                        image={
                          item.customisations?.[0]?.imageUrl ||
                          "/placeholder.jpg"
                        }
                        alt={item.eventCustomisationName || "Fallback Content"}
                      />
                      <CardContent
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="subtitle1">
                          {item.eventCustomisationName || "Unnamed Content"}
                        </Typography>
                        <Tooltip title="Preview Image">
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation(); 
                              setPreviewImage(
                                item.customisations?.[0]?.imageUrl ||
                                  "/placeholder.jpg"
                              );
                            }}
                          >
                            <Preview />
                          </IconButton>
                        </Tooltip>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>

          <Box sx={{ flex: 2, p: 2, overflow: "auto" }}>
            <Typography 
            variant="h6" 
            gutterBottom
            sx={{
              marginBottom:{xs:"3%",md:"unset"}
            }}
            >
              {fallbackContent?.fallbackContentSelectedId
                ? "Edit Fallback Content"
                : "No Fallback Content Selected"}
            </Typography>

            <Grid 
            container 
            spacing={2}
            sx={{
              height:{xs:"75%",md:"unset"},
              overflow:{xs:"scroll",md:"unset"}
            }}
            >
              {screenUsers?.length > 0 ? (
                screenUsers.map((user) => (
                  <Grid item xs={12} sm={6} md={4} key={user?.id}>
                    <Paper elevation={2} sx={{ p: 2 }}>
                      <Box display="flex" alignItems="center" gap={2}>
                        <Checkbox
                          checked={selectedScreenUsers.includes(user?.id)}
                          onChange={() => handleScreenUserSelect(user?.id)}
                        />
                        <Box>
                          <Typography>{user.screenUserName}</Typography>
                          <Typography variant="body2" color="textSecondary">
                            {user.typeOfScreen}
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                ))
              ) : (
                <Typography variant="body2" sx={{ mt: 5 }}>
                  No screen users available.
                </Typography>
              )}
            </Grid>

            <Box
              sx={{
                textAlign: "center",
                mt: 3,
                display: "flex",
                justifyContent: "flex-end",
                gap: "1rem",
              }}
            >
              <Button
                variant="outlined"
                color="error"
                onClick={() => {
                  setshowmodel(false);
                }}
                sx={{ textTransform: "none" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  handleBatchUpdateMrs(e);
                  setshowmodel(false);
                }}
                sx={{ textTransform: "none" }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Paper>

        {previewImage && (
          <Modal open onClose={() => setPreviewImage(null)}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                bgcolor: "rgba(0,0,0,0.8)",
                position: "relative",
              }}
            >
              <IconButton
                onClick={() => setPreviewImage(null)}
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  color: "white",
                  zIndex: 1,
                }}
              >
                <Close />
              </IconButton>
              {previewImage.endsWith(".mp4") ||
              previewImage.endsWith(".webm") ||
              previewImage.endsWith(".ogg") ? (
                <video
                  controls
                  style={{
                    maxWidth: "90%",
                    maxHeight: "90%",
                    border: "2px solid white",
                    borderRadius: "8px",
                  }}
                >
                  <source src={previewImage} type="video/mp4" />
                  <source src={previewImage} type="video/webm" />
                  <source src={previewImage} type="video/ogg" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{
                    maxWidth: "90%",
                    maxHeight: "90%",
                    border: "2px solid white",
                    borderRadius: "8px",
                  }}
                />
              )}
            </Box>
          </Modal>
        )}
      </Box>
    </Modal>
  );
};

export default FallBackContent;
